import AppRouter from '@/router/router'
import '@/styles/global.css'

export function App() {
  return <AppRouter />
}

export default App
